import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import InputAdornment from "@mui/material/InputAdornment";
import './Getquotations.css';
import FrameImage from "../assets/img/images/images/Frame.png";
import AddIcon from '@mui/icons-material/Add';
import Header from "../components/Header";
import Footer from "../components/Footer";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from "react-helmet-async";
import Emailjs from "emailjs-com";
import WhatsappButton from '../components/WhatsappButton';

const GetQuotations = () => {

  useEffect(() => {
    AOS.init();
  }, []);

  const theme = createTheme({
    components: {
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            backgroundColor: "#00a6d6",
            color: "#fff",
            fontWeight: "bold",
          },
          deleteIcon: {
            color: "#fff",
          },
        },
      },
    },
  });

  const [selectedItems, setSelectedItems] = useState([]);

  const [unselectedItems, setUnselectedItems] = useState([
    "Trampoline",
    "Performance Trampoline",
    "Foam Pit/ Balance",
    "Dodge Ball",
    "Wipe Out",
    "Air Bag",
    "Softplay",
    "Toddler",
    "Roleplay",
    "Car track",
    "Zipline",
    "Slide",
    "Sand Area",
    "Ball Pool",
    "Doughnut Slide",
    "Climbing Wall",
    "Ninja Park",
    "Interactive Games",
    "Entrance Software"
  ]);

  const handleDelete = (game) => {
    setSelectedItems((prev) => prev.filter((g) => g !== game));
    setUnselectedItems((prev) => [...prev, game]);
  };

  const handleAdd = (game) => {
    setUnselectedItems((prev) => prev.filter((g) => g !== game));
    setSelectedItems((prev) => [...prev, game]);
  };

  const [item, setItem] = useState({
    firstname: "",
    lastname: "",
    email: "",
    mobilenumber: "",
    countryCode: "+1",  // ✅ Default country code
    locationsize: "",
    games: [],
    notARobot: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckBoxChange = (game) => {
    setItem((prev) => ({
      ...prev,
      games: prev.games.includes(game)
        ? prev.games.filter((g) => g !== game)
        : [...prev.games, game],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ First Name Validation
    if (!item.firstname.trim()) {
      alert("Please enter your first name.");
      return;
    }

    // ✅ Email Validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!item.email.trim() || !emailRegex.test(item.email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // ✅ Mobile Number Validation
    const alphaRegex = /[a-zA-Z]/;
    if (!item.mobilenumber.trim()) {
      alert("Please enter your mobile number.");
      return;
    }
    if (alphaRegex.test(item.mobilenumber)) {
      alert("Mobile number should not contain alphabet characters.");
      return;
    }

    if (!item.notARobot) {
      alert("Please confirm you are not a robot.");
      return;
    }

    const templateParams = {
      firstname: item.firstname,
      lastname: item.lastname,
      email: item.email,
      countryCode: item.countryCode,
      mobilenumber: item.mobilenumber,
      locationsize: item.locationsize,
      games: selectedItems.join(", "),
    };

    Emailjs.send(
      "service_xzvvd2a",
      "template_rhj3e7b",
      templateParams,
      "h1mSaptAL66LjB2S3"
    )
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        alert("Email sent successfully!");
        window.location.reload();

        // ✅ Reset form fields
        setItem({
          firstname: "",
          lastname: "",
          email: "",
          mobilenumber: "",
          countryCode: "+1",
          locationsize: "",
          games: [],
          notARobot: false,
        });

        // ✅ Reset chips
        setSelectedItems([]);
        setUnselectedItems([
          "Trampoline",
          "Performance Trampoline",
          "Foam Pit/ Balance",
          "Dodge Ball",
          "Wipe Out",
          "Air Bag",
          "Softplay",
          "Toddler",
          "Roleplay",
          "Car track",
          "Zipline",
          "Slide",
          "Sand Area",
          "Ball Pool",
          "Doughnut Slide",
          "Climbing Wall",
          "Ninja Park",
          "Interactive Games",
          "Entrance Software"
        ]);

      })
      .catch((err) => {
        console.error("FAILED...", err);
        alert("There was an error submitting the form.");
      });
  };

  return (
    <div>
      <Helmet>
        <meta name="trampoline park with soft play" content="Experience the best trampoline park with soft play at GEM. 
        Enjoy top-quality trampolines and fun-filled activities for all ages
        in a safe, exciting environment" />
      </Helmet>
      <Header />
      <WhatsappButton
        altText="Chat with us on WhatsApp"
        iconSize={70}
      />
      <div className="container">
        <div className="left-section" data-aos="zoom-in-right" data-aos-duration="2500">
          <h2>Get Quotation</h2>
          <p>
            Looking for tailored solutions to meet your business needs? Request a
            quote now and let us help you find the perfect fit.
          </p>
        </div>
        <div className="right-section" data-aos="zoom-in-left" data-aos-duration="2500">
          <div className="enquiry-box">
            <h2>Enquire Now</h2>
            <form onSubmit={handleSubmit}>
              <div className="input-row1">
                <TextField
                  required
                  id="outlined-required"
                  label="First name"
                  name="firstname"
                  value={item.firstname}
                  onChange={handleChange}
                />
                <TextField
                  id="outlined-required"
                  label="Last Name"
                  name="lastname"
                  value={item.lastname}
                  onChange={handleChange}
                />
              </div>
              <div className="input-row2">
                <TextField
                  required
                  id="outlined-required"
                  label="email"
                  name="email"
                  value={item.email}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                />
                <div
                  className="input-row2"
                  style={{ display: "flex", gap: "1%" }}
                >
                  {/* ✅ Country Code Picker */}
                  <div style={{ display: "flex" }}>
                    <div>
                      <PhoneInput
                        country={"us"}
                        enableSearch={true}
                        value={item.countryCode.replace("+", "")}
                        onChange={(value, countryData) =>
                          setItem((prev) => ({
                            ...prev,
                            countryCode: `+${countryData?.dialCode || "1"}`,
                            mobilenumber: prev.mobilenumber,
                          }))
                        }
                        inputStyle={{
                          width: "100px",
                          marginLeft: "10px",
                          height: "55px",
                        }}
                      />
                    </div>
                    {/* ✅ Mobile Number Input */}
                    <TextField
                      id="outlined-number"
                      label="Mobile Number"
                      name="mobilenumber"
                      value={item.mobilenumber}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Location size
                </FormLabel>
                <RadioGroup
                  row
                  name="locationsize"
                  value={item.locationsize}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="50-200 sq mtr"
                    control={<Radio />}
                    label="50-200 sq mtr"
                  />
                  <FormControlLabel
                    value="201-500 sq mtr"
                    control={<Radio />}
                    label="201-500 sq mtr"
                  />
                  <FormControlLabel
                    value="501-1000 sq mtr"
                    control={<Radio />}
                    label="501-1000 sq mtr"
                  />
                  <FormControlLabel
                    value="1001 and above sq mtr"
                    control={<Radio />}
                    label="1001 and above sq mtr"
                  />
                </RadioGroup>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Games
                </FormLabel>
              </FormControl>
              <ThemeProvider theme={theme}>
                <Stack direction="row" spacing={1} className="chip-container">
                  {selectedItems.map((item) => (
                    <Chip
                      key={item}
                      label={item}
                      onDelete={() => handleDelete(item)}
                      onClick={() => handleCheckBoxChange(item)}
                    />
                  ))}
                </Stack>

                <Stack
                  direction="row"
                  spacing={1}
                  marginTop={2}
                  className="chip-container"
                >
                  {unselectedItems.map((item) => (
                    <Chip
                      key={item}
                      onClick={() => handleAdd(item)}
                      style={{
                        backgroundColor: "#f0f0f0",
                        color: "#000",
                        border: "1px solid #ccc",
                        cursor: "pointer",
                      }}
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {item}
                          <AddIcon
                            fontSize="small"
                            style={{ marginLeft: "5px" }}
                          />
                        </div>
                      }
                    />
                  ))}
                </Stack>
              </ThemeProvider>
              <div className="checkbox-row">
                <input
                  type="checkbox"
                  id="not-a-robot"
                  checked={item.notARobot || false}
                  onChange={(e) =>
                    setItem((prev) => ({
                      ...prev,
                      notARobot: e.target.checked,
                    }))
                  }
                />
                <label htmlFor="not-a-robot">I’m not a robot</label>
                <img src={FrameImage} alt="Recaptcha Icon" />
              </div>
              <button
                type="submit"
                className="submit-button"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GetQuotations;
